import { Accordion } from 'flowbite-react';
const AiAgentsFAQ: React.FC = () => {
    return (
        <>
            <Accordion>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                         What is an autonomous agent?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            An autonomous agent is an AI-driven system capable of making decisions and performing tasks independently across multiple enterprise applications. Through MCP integrations and agent orchestration, these agents automate complex business workflows safely within an agent sandbox.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How do you prevent agents from taking unsafe actions?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                           Every agent operates within a secure agent sandbox governed by Model Context Protocol (MCP) permissions. Human-in-loop controls, validation steps, and detailed audit logs ensure all agent actions are monitored and reproducible, keeping AI automation safe and compliant.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        Can agents interact with our ERP or financial systems?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                           Absolutely. We deploy MCP-enabled autonomous agents that integrate seamlessly with major ERP and financial platforms such as SAP, Oracle ERP, Salesforce, NetSuite, and Workday. These integrations utilize secure API connectors, OAuth authentication, and role-based access controls to ensure all agent interactions are safe, authorized, and fully traceable, leveraging enterprise-grade orchestration frameworks.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        What auditing and traceability are available?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            Every action performed by an autonomous agent is recorded in secure, immutable audit trails. Thanks to Model Context Protocol (MCP) integrations, there is full transparency into when, why, and how agents take each action. The audit logs include detailed timestamps, decision rationale, accessed data sources, and the entire approval workflow. This traceability is essential for regulatory compliance, governance, and providing explainability for all automated decisions.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                       How do we test agent behavior before production?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            Every project begins in a controlled agent sandbox. This testing phase allows you to validate logic, review audit logs, and refine orchestration safely before full deployment in enterprise environments.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How long does a typical agent POC take?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            A standard proof of concept (POC) for autonomous agents typically runs between 4-6 weeks. It includes design, sandbox testing, human oversight setup, and secure MCP integrations for safe, traceable automation.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                       Can business users configure agents without coding?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                           Yes. We offer low-code and no-code agent builder platforms with intuitive drag-and-drop interfaces and prebuilt templates that empower citizen developers and business users to design and configure simple autonomous workflows without writing code. These tools ensure business agility while maintaining IT governance, security, and compliance.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        Do you provide training for our business teams?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            Absolutely. We deliver comprehensive workshops, hands-on training sessions, and certification programs tailored to business users. These enable your teams to confidently configure, monitor, and manage agent workflows within secure, governed frameworks, accelerating adoption and maximizing the value of autonomous AI agents.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
            </Accordion>
        </>
    );
};

export default AiAgentsFAQ;
